import { createSlice } from '@reduxjs/toolkit';

type State = {
  smartGuardTour: boolean,
}

const initialState: State = { smartGuardTour: false };

const mapScreenSlice = createSlice({
  name: 'mapScreen',
  initialState,
  reducers: {
    updateMapScreenSelection(state: State, action: { payload: boolean }) {
      state.smartGuardTour = action.payload;
    },
  },
});

export const { updateMapScreenSelection } = mapScreenSlice.actions;

export default mapScreenSlice.reducer;
